import type { Components, Theme } from "@mui/material";

export const cardActionsTheme: Components<Theme>["MuiCardActions"] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
      margin: "24px",
    }),
  },
};
